<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label, additionalTranslate)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <InputNumber :class="[{ 'p-error' : error }]" v-on="listeners" :value="value" :id="uuid" :disabled="disable" style="width: 100%" :minFractionDigits="minFractionDigits" locale="pt-BR"/>
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffInputNumber",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            additionalTranslate: {type: Object, default: () => {}},
            minFractionDigits: {type: Number, default: 2},
        },

        data(){
            return {
                uuid: Utils.uuid(),
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    InputText: event => this.$emit('InputNumber', event.target.value)
                };
            },
        },

    }
</script>

<style scoped>

</style>
